const getFormatedPrice = (price) => {
  return parseFloat(price).toFixed(2) + " MAD";
};

export default getFormatedPrice;
